import axios from "../config/axios";

/**
 * Consultar el estado del whatsapp si  esta online o offline.
 * @param {*} phone: number of patient
 */
export async function phoneState(phone) {
  return await axios.get(
    "gestion_notificaciones/notificaciones/api/v1/phone_state",
    {
      params: {
        phone
      }
    }
  );
}
/**
 * consulta los templates activos del tipo seleccionado.
 * @param {*} type: string of selection
 */
export async function optionsTemplate(type) {
  return await axios.get(
    "gestion_notificaciones/notificaciones/api/v1/options_template",
    {
      params: {
        type
      }
    }
  );
}
/**
 * consulta los parametros necesarios para el template seleccionado.
 * @param {*} name: string of selection
 */
export async function parametersTemplate(name) {
  return await axios.get(
    "gestion_notificaciones/notificaciones/api/v1/parameters_template",
    {
      params: {
        name
      }
    }
  );
}

/**
 * Function to send message
 * @param {String} documento
 * @param {Objet} message
 * @param {Array} channels
 * @returns
 "/gestion_notificaciones/notificaciones/api/v1/send_notification",
 */
export async function sendNotification(documento, message, channels) {
  return await axios.post(
    "/gestion_notificaciones/notificaciones/api/v1/send_notification",
    {
      documento,
      message,
      channels
    }
  );
}
/**
 * Function to send mass notifications
 * @param {Array} state_therapy
 * @param {Array} name_therapy
 * @param {Array} name_scheme
 * @param {Objet} message
 * @param {Array} channels
 * @returns
 */
export async function sendMassNotifications(
  name_scheme,
  name_therapy,
  state_therapy,
  message,
  channels
) {
  return await axios.post(
    "/gestion_notificaciones/notificaciones/api/v1/send_massive",
    {
      name_scheme,
      name_therapy,
      state_therapy,
      message,
      channels
    }
  );
}
/**
 * Function() to search list of taype message selected
 * @param {String} lista
 * @returns
 */
export async function urlTemplate(lista) {
  return await axios.get(
    "/gestion_notificaciones/notificaciones/api/v1/get_list",
    {
      params: {
        lista
      }
    }
  );
}
/**
 * endpoint para consultar los documentos asociados a un paciente
 * @param {Number} documeto documento del paciente
 * @param {Number} limite limite de documentos a buscar
 * @returns
 */
export async function getFiles(documento, limite) {
  return await axios.post(
    "/gestion_notificaciones/notificaciones/api/v1/get_files",
    {
      documento,
      limite
    }
  );
}
/**
 * Endpoint para consultar los mensajes que se le han enviado a un paciente desde la app
 * @param {Number} documento
 * @param {Number} limite
 * @returns
 */
export async function getMessages(documento, limite) {
  return await axios.post(
    "/gestion_notificaciones/notificaciones/api/v1/message_history",
    {
      documento,
      limite
    }
  );
}



// WEBPACK FOOTER //
// ./src/apiService/request/crudMendajes.js